var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.6665L9.075 11.0498C9.34888 11.2326 9.67075 11.3301 10 11.3301C10.3292 11.3301 10.6511 11.2326 10.925 11.0498L17.5 6.6665M4.16667 15.8332H15.8333C16.2754 15.8332 16.6993 15.6576 17.0118 15.345C17.3244 15.0325 17.5 14.6085 17.5 14.1665V5.83317C17.5 5.39114 17.3244 4.96722 17.0118 4.65466C16.6993 4.3421 16.2754 4.1665 15.8333 4.1665H4.16667C3.72464 4.1665 3.30072 4.3421 2.98816 4.65466C2.67559 4.96722 2.5 5.39114 2.5 5.83317V14.1665C2.5 14.6085 2.67559 15.0325 2.98816 15.345C3.30072 15.6576 3.72464 15.8332 4.16667 15.8332Z",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8bb50d3ab5994a6dfba11266516550bf.svg";
export { ForwardRef as ReactComponent };